import exportPdf from './exportPdf'
import pages from './pages'

const questionControl = {
  exportPdf,
  pages,
}

export default questionControl
